
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.27696 9.88434L6.78499 11.0117C6.59587 11.4451 5.99649 11.4451 5.80738 11.0117L5.3154 9.88434C4.87757 8.88102 4.08952 8.0824 3.10652 7.64583L1.75235 7.04441C1.32181 6.8532 1.32181 6.22654 1.75235 6.03533L3.06422 5.4527C4.0725 5.0049 4.87469 4.17667 5.30504 3.13914L5.8034 1.93767C5.98832 1.49181 6.60403 1.4918 6.78897 1.93767L7.28733 3.13915C7.71768 4.17667 8.51986 5.0049 9.52814 5.4527L10.84 6.03533C11.2706 6.22654 11.2706 6.8532 10.84 7.04441L9.48584 7.64583C8.50285 8.0824 7.7148 8.88102 7.27696 9.88434Z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M11.8502 13.4418L11.7119 13.759C11.6107 13.9912 11.2893 13.9912 11.1881 13.759L11.0497 13.4418C10.8031 12.8762 10.359 12.4259 9.80482 12.1796L9.37864 11.9901C9.1482 11.8877 9.1482 11.5525 9.37864 11.4501L9.78099 11.2712C10.3494 11.0185 10.8015 10.5516 11.0439 9.96677L11.1859 9.624C11.2849 9.3851 11.615 9.3851 11.714 9.624L11.8561 9.96677C12.0984 10.5516 12.5505 11.0185 13.119 11.2712L13.5213 11.4501C13.7518 11.5525 13.7518 11.8877 13.5213 11.9901L13.0951 12.1796C12.541 12.4259 12.0968 12.8762 11.8502 13.4418Z","fill":"currentColor"}})])
          )
        }
      }
    